// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { SpanWithData } from '../'


export const ClientInvestmentPolicyTableRow = ({ policy, empty, numberOfColumns }) => (
  empty
    ? <tr>
        <td colSpan={numberOfColumns}>
          No records
        </td>
      </tr>
    : <tr>
        <td>
          {policy.contributor.fullName}
        </td>
        <td>
          <SpanWithData forField='ClientInvestmentPolicyContributorType' searchKey={policy.contributorType} />
        </td>
        <td>
          {`R ${policy.amount}`}
        </td>
        <td>
          {policy.liveStatus}
        </td>
        <td>
          {policy.activationOn
            ? moment(policy.activationOn).format('DD MMM YYYY')
            : '-'
          }
        </td>
        <td>
          {policy.deprecationOn
            ? moment(policy.deprecationOn).format('DD MMM YYYY')
            : '-'
          }
        </td>
      </tr>
)

ClientInvestmentPolicyTableRow.propTypes = {
  policy: PropTypes.object,
  empty: PropTypes.bool,
  numberOfColumns: PropTypes.number
}



// WEBPACK FOOTER //
// ./src/components/client-investment-policies/ClientInvestmentPolicyTableRow.js